import { configOptions } from '../../helpers/axios';
import clientAxios from './../../config/axios';

export const getAllUsers = ({ filter, pagination }: any, token: string) => {
  const filterTmp = filter ?? '';
  const complement = pagination.page
    ? `page=${pagination.page}&items_per_page=${pagination.rowsPerPage}${filterTmp}`
    : `all=1${filterTmp}`;
  const url = `/users?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  return clientAxios.get(url, configOptions(token));
};

export const updateUsers = (user: any, token: string) => {
  const url = `/users?country=${process.env.REACT_APP_ENV_COUNTRY}&id=${user.id}`;
  return clientAxios.put(url, user, configOptions(token));
};

export const createUser = (user: any, token: string) => {
  const url = `/users`;
  return clientAxios.post(url, user, configOptions(token));
};
